import { styled } from "styled-components";

export const InfoPopupPositionContainer = styled.div`
  position: relative;
`;

export const InfoPopupContainer = styled.div`
  position: absolute;
`;

export const InfoPopupIcon = styled.button`
  cursor: pointer;
  position: relative;
  top: -6px;
  display: flex;
  align-items: center;
`;

export const InfoPopupText = styled.p`
  position: fixed;
  max-width: 300px;
  text-align: left;
  width: fit-content;
  height: fit-content;
  padding: 12px;
  background: white;
  box-shadow:
    rgba(0, 0, 0, 0.05) 0 6px 24px 0,
    rgba(0, 0, 0, 0.08) 0 0 0 1px;
  z-index: 5;
  border-radius: 5px;
`;
